import { TOtpStore } from '~/store/otp-verification/types.ts';

export const otpFulfilled = (state: TOtpStore) => {
  state.loading = false;
  state.error = null;
  state.status = '';
};

export const otpPending = (state: TOtpStore) => {
  state.loading = true;
};
